import Request from '@/plugins/request'

export function getUserLevels(params) {
  return Request.get('user-levels', {
    params,
  })
}

export function getLevelList(params) {
  return Request.get('user-levels/list', { params })
}

export function updateUserLevel(id, data) {
  return Request.put(`user-levels/${id}`, data)
}

export function editUserLevel(id) {
  return Request.get(`user-levels/${id}/edit`)
}
